import React from 'react'

import withOpenMaps from '../../withOpenMaps'

const MyMapComponent = withOpenMaps(
  ({ section, MapContainer, Marker, Popup, TileLayer }) => {
    if (!section.additional.latitude || !section.additional.longitude) {
      return null
    }

    const position = [
      parseFloat(section.additional.latitude),
      parseFloat(section.additional.longitude)
    ]

    return (
      <MapContainer center={position} zoom={14}>
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            <div style={{ display: 'inline-block' }}>{section.additional.address}</div>
          </Popup>
        </Marker>
      </MapContainer>
    )
  }
)
const ProfileSectionMap = ({ section }) => {
  const w = () => {
    //console.log(section.additional)
    if (section.additional.latitude && section.additional.longitude) {
      return <MyMapComponent section={section} />
    }

    //console.log("Nothing")
    return null
  }

  if (section.additional) {
    return (
      <div>
        <p itemType="http://data-vocabulary.org/Organization" itemScope="">
          <span itemProp="address" itemType="http://data-vocabulary.org/Address">
            {section.additional.address}
          </span>
        </p>
        {w()}
      </div>
    )
  }

  return null
}

export default ProfileSectionMap
